import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Linkedin, Instagram, Mail, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-16">

      <div className="max-w-7xl mx-auto px-6 py-12">

        {/* TOP SECTION */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-10">

          {/* Job Seekers */}
          <div>
            <h4 className="font-semibold text-gray-800 mb-4">For Job Seekers</h4>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/jobs">Search Jobs</Link></li>
              <li><Link to="/companies">Browse Companies</Link></li>
              <li><Link to="/resume-writing">Resume Writing</Link></li>
              <li><Link to="/career-advice">Career Advice</Link></li>
              <li><Link to="/learning">Learning & Courses</Link></li>
            </ul>
          </div>

          {/* Employers / ATS */}
          <div>
            <h4 className="font-semibold text-gray-800 mb-4">Hiring Solutions</h4>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/post-job">Post a Job</Link></li>
              <li><Link to="/resume-database">Resume Database</Link></li>
              <li><Link to="/ats">Applicant Tracking System</Link></li>
              <li><Link to="/recruiter-tools">Recruiter Tools</Link></li>
              <li><Link to="/pricing">Recruiter Pricing</Link></li>
            </ul>
          </div>

          {/* Recruiter Help */}
          <div>
            <h4 className="font-semibold text-gray-800 mb-4">Recruiter Help</h4>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/recruiter/help">Recruiter Help Center</Link></li>
              <li><Link to="/recruiter/support">Support</Link></li>
              <li><Link to="/recruiter/faq">Recruiter FAQ</Link></li>
              <li><Link to="/recruiter/login">Recruiter Login</Link></li>
              <li><Link to="/recruiter/register">Recruiter Registration</Link></li>
            </ul>
          </div>

          {/* SEO Links */}
          <div>
            <h4 className="font-semibold text-gray-800 mb-4">Popular Searches</h4>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/jobs-in-ahmedabad">Jobs in Ahmedabad</Link></li>
              <li><Link to="/sales-jobs">Sales Jobs</Link></li>
              <li><Link to="/it-jobs">IT Jobs</Link></li>
              <li><Link to="/marketing-jobs">Marketing Jobs</Link></li>
              <li><Link to="/remote-jobs">Remote Jobs</Link></li>
            </ul>
          </div>

          {/* Company Info */}
          <div>
            <h4 className="font-semibold text-gray-800 mb-4">Contact</h4>

            <div className="text-sm text-gray-600 space-y-3">

              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1" />
                <p>
                  JobGenie - from DS Group
                  <br/>
                  Ahmedabad, Gujarat  
                  India
                </p>
              </div>

              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                <a href="mailto:support@jobgenie.in">
                  support@jobgenie.in
                </a>
              </div>

              {/* Social icons */}
              <div className="flex gap-3 pt-2">
                <a href="#"><Facebook className="w-5 h-5 text-gray-600 hover:text-blue-600"/></a>
                <a href="#"><Twitter className="w-5 h-5 text-gray-600 hover:text-blue-600"/></a>
                <a href="#"><Linkedin className="w-5 h-5 text-gray-600 hover:text-blue-600"/></a>
                <a href="#"><Instagram className="w-5 h-5 text-gray-600 hover:text-blue-600"/></a>
              </div>

            </div>
          </div>

        </div>


        {/* SEO LONG LINKS (Google ranking) */}
        <div className="border-t border-gray-200 pt-6 mb-6 text-sm text-gray-500">

          <p className="mb-2 font-medium text-gray-700">
            Popular Job Categories
          </p>

          <p className="leading-7">
            Jobs in Ahmedabad • Jobs in Mumbai • Jobs in Delhi • Jobs in Bangalore • 
            Sales Jobs • Marketing Jobs • HR Jobs • IT Jobs • Finance Jobs • 
            Freshers Jobs • Remote Jobs • Work From Home Jobs
          </p>

        </div>


        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-6 flex flex-col md:flex-row justify-between items-center">

          <p className="text-sm text-gray-600 mb-3 md:mb-0">
            © {new Date().getFullYear()} JobGenie.in
          </p>

          <div className="flex gap-6 text-sm text-gray-600">
            <Link to="/terms">Terms</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/fraud-alert">Fraud Alert</Link>
            <Link to="/support">Support</Link>
          </div>

        </div>

      </div>
    </footer>
  );
};

export default Footer;